export const bookingInfoStyles = {
  pinDropIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  checkIcon: {
    color: 'rgb(199, 207, 252)',
  },
  title: {
    fontWeight: '600',
    fontSize: '1.7rem',
  },
  locationName: {
    fontWeight: '500',
    fontSize: '1.15rem',
  },
  cityName: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1rem',
    fontWeight: '400',
    marginLeft: '0.5rem',
  },
  label: {
    color: 'rgba(0, 0, 0, 0.38)',
    marginLeft: '-0.8em',
  },
  text: {
    marginBottom: '0.5rem',
  },
} as const;
